// --- SchedulePreview.js ---
import React from 'react';
import { Card, Button, ListGroup } from 'react-bootstrap';
import './SchedulePreview.css';

const SchedulePreview = ({ selectedEvents, vendorId, weekData }) => {
  console.log("✅ Rendering Schedule Preview", selectedEvents);

  const handleConfirmSchedule = () => {
    alert(`✅ Scheduled ${selectedEvents.length} event(s) for vendor ${vendorId} in week ${weekData.week}`);
    // You can trigger a real backend call here to save the schedule
  };

  if (!selectedEvents || selectedEvents.length === 0) {
    return <p className="text-muted mt-3">⚠️ No draft events selected for this week.</p>;
  }

  return (
    <Card className="schedule-preview shadow-sm mt-4">
      <Card.Body>
        <Card.Title className="text-primary mb-3">
          📋 Draft Schedule (Week {weekData.week}) — {selectedEvents.length} Event{selectedEvents.length > 1 ? 's' : ''}
        </Card.Title>

        <ListGroup variant="flush" className="rounded">
          {selectedEvents.map((event) => (
            <ListGroup.Item key={event.id} className="d-flex justify-content-between align-items-center">
              <span><strong>{event.event_name}</strong> – {event.location}</span>
            </ListGroup.Item>
          ))}
        </ListGroup>

        <div className="text-end mt-4">
          <Button
            variant="success"
            onClick={handleConfirmSchedule}
            disabled={selectedEvents.length === 0}
            className="px-4 py-2"
          >
            ✅ Confirm & Schedule Events
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SchedulePreview;
